import { useEffect, useState } from "react";
export var useGetInformationSteps = function (stepKey) {
    var _a = useState({}), info = _a[0], setInfo = _a[1];
    useEffect(function () {
        if (!stepKey)
            return;
        try {
            var raw = localStorage.getItem("steps") || "[]";
            var steps = JSON.parse(raw);
            var step = steps.find(function (s) { return s.id === stepKey || (s.pathUrl || "") === stepKey; });
            setInfo((step === null || step === void 0 ? void 0 : step.stepInformation) || {});
        }
        catch (error) {
            console.error("Error al leer stepInformation:", error);
            setInfo({});
        }
    }, [stepKey]);
    return info;
};
/**
 * Get multiple properties from a specific step in localStorage
 * @param stepId - The ID of the step to get properties from
 * @param propertyNames - Array of property names to retrieve
 * @returns Object with requested properties or empty object if step not found
 */
export var getStepProperties = function (stepId, propertyNames) {
    try {
        var steps = JSON.parse(localStorage.getItem("steps") || "[]");
        var step_1 = steps.find(function (s) { return s.id === stepId; });
        if (!step_1)
            return {};
        // Return object with requested properties
        var result_1 = {};
        propertyNames.forEach(function (propName) {
            result_1[propName] = step_1[propName];
        });
        return result_1;
    }
    catch (error) {
        console.error("Error getting step properties:", error);
        return {};
    }
};
/**
 * Get all data from a specific step in localStorage
 * @param stepId - The ID of the step to retrieve
 * @returns The complete step object or undefined if not found
 */
export var getStepData = function (stepId) {
    try {
        var steps = JSON.parse(localStorage.getItem("steps") || "[]");
        return steps.find(function (s) { return s.id === stepId; }) || null;
    }
    catch (error) {
        console.error("Error getting step data:", error);
        return null;
    }
};
